import { requestApi } from '../util/network'
// 新增店铺留言
export const addInquiry =
(goods_id, subject, email, purchase_quantity, purchase_quantity_type, content, captcha) =>
  requestApi(
    '/memberinquiry/inquiry_save',
    'POST',
    {
      goods_id: goods_id,
      subject: subject,
      email: email,
      purchase_quantity: purchase_quantity,
      purchase_quantity_type: purchase_quantity_type,
      content: content,
      captcha: captcha
    },
    'member'
  )
export const getInquiryInfo =
    (goods_id) =>
      requestApi(
        '/memberinquiry/inquiry_info',
        'POST',
        {
          goods_id: goods_id
        },
        'member'
      )
